import React from 'react';
import { Cushion, Typography, MaxWidth } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const NoResults = () => (
  <Cushion all="large">
    <MaxWidth component="div" maxWidth={479} center>
      <Cushion bottom="medium">
        <Typography preset="subtitle--large" component="div">
          <Trans i18nKey="teams:no_league_table_results">Sorry, there are no tables to show</Trans>
        </Typography>
      </Cushion>
      <Cushion bottom="medium">
        <Typography preset="body--small" color="dovegrey" component="div">
          <Trans i18nKey="teams:no_league_table_results_description">
            Looks like there aren&lsquo;t any tables
          </Trans>
        </Typography>
      </Cushion>
    </MaxWidth>
  </Cushion>
);

export default NoResults;
